// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"33":"ceed3e14","653":"000e6ee8","917":"f1aca5b8"}[chunkId] + ".js";
};